import { render } from "./SiteInfo.vue?vue&type=template&id=55c70ace&scoped=true&lang=html"
import script from "./SiteInfo.vue?vue&type=script&lang=js"
export * from "./SiteInfo.vue?vue&type=script&lang=js"

import "./SiteInfo.vue?vue&type=style&index=0&id=55c70ace&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-55c70ace"

export default script